// extracted by mini-css-extract-plugin
module.exports = {"clickableTableHeader":"artist_clickableTableHeader__3voRi","hasError":"artist_hasError__2VgIX"};